var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_save"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 23",
    cx: 12,
    cy: 12.6906,
    r: 9,
    stroke: "#6D6B70",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1925",
    d: "M7.5 12.6906L10.1578 15.6906L16.1578 9.69055",
    stroke: "#6D6B70",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginSave);
export default __webpack_public_path__ + "static/media/LoginSave.cfe761cd36df4e325e4df4e70f6953f2.svg";
export { ForwardRef as ReactComponent };